import { createSelector } from 'reselect'

const getStorefrontOwnerData = state => state.storefront.owner
const getLessonsData = state => state.lessons

const storefront_owner_sort_selector = createSelector(
	[ getStorefrontOwnerData, getLessonsData ],
	(ownerState, lessons) => {

		const initIndex = Math.min(ownerState.lessons.drag_init_index, ownerState.lessons.drag_end_index)
		const endIndex = Math.max(ownerState.lessons.drag_init_index, ownerState.lessons.drag_end_index)
		let sortedEntities
		if (initIndex !== endIndex) {
			const entities = ownerState.lessons.entities
			sortedEntities = entities.filter(function(element, index) {
				if (index >= initIndex && index <= endIndex) {
					return true
				}
			}).map(function(entityUID) {
				return lessons[entityUID].data.id
			})
		} else {
			sortedEntities = []
		}
		return sortedEntities
	}
)

export default storefront_owner_sort_selector
